import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, SettingsIcon, KeyIcon, BookOpenIcon, RocketIcon, HomeIcon } from 'lucide-react';
import Button from './Button';
import { Link, useLocation } from 'react-router-dom';
import APIKeySettings from './APIKeySettings';
import Wizard from './Wizard';
import { useTranslation } from '../i18n/useTranslation';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAPISettingsOpen, setIsAPISettingsOpen] = useState(false);
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const location = useLocation();
  const {
    t
  } = useTranslation();
  // Listen for the custom event to open API settings
  useEffect(() => {
    const handleOpenAPISettings = () => {
      setIsAPISettingsOpen(true);
    };
    window.addEventListener('open-api-settings', handleOpenAPISettings);
    return () => {
      window.removeEventListener('open-api-settings', handleOpenAPISettings);
    };
  }, []);
  return <nav className="border-b border-gray-200 bg-white sticky top-0 z-50 shadow-sm" data-id="element-1984">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1985">
        <div className="flex justify-between h-16 items-center" data-id="element-1986">
          <div className="flex flex-col items-center" data-id="element-1987">
            <Link to="/" data-id="element-1988">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rhREvAJ4b5296S85upFAnM/logonew.png" alt="Shopilots Logo" className="h-8 w-auto" data-id="element-1989" />
              <div className="text-sm font-bold text-purple-300" data-id="element-1990">Shopilots</div>
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-1991">
            <Link to="/home1" className="text-dark hover:text-primary transition-colors flex items-center gap-1" data-id="element-1992">
              <HomeIcon className="h-4 w-4" data-id="element-1993" />
              Home
            </Link>
            <a href="/#platforms" className="text-dark hover:text-primary transition-colors cursor-pointer" data-id="element-1994">
              {t('nav.products')}
            </a>
            <Link to="/pricing" className="text-dark hover:text-primary transition-colors" data-id="element-1995">
              {t('nav.pricing')}
            </Link>
            <Link to="/compare-to-intercom" className="text-dark hover:text-primary transition-colors" data-id="element-1996">
              Compare To Intercom
            </Link>
            <Link to="/blog" className="text-dark hover:text-primary transition-colors flex items-center" data-id="element-1997">
              <BookOpenIcon className="h-4 w-4 mr-1" data-id="element-1998" />
              {t('nav.blog')}
            </Link>
            <a href="https://shoppingexpert.ai" target="_blank" rel="noopener noreferrer" className="text-dark hover:text-primary transition-colors" data-id="element-1999">
              {t('nav.shoppingExpert')}
            </a>
            <a href="https://chat.shopilots.com/signup?product=shopilots" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-4 rounded-xl font-semibold transition-all flex items-center gap-2 whitespace-nowrap" data-id="element-2000">
              <RocketIcon className="h-4 w-4" data-id="element-2001" />
              Try Now
            </a>
          </div>

          <div className="md:hidden" data-id="element-2002">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-dark hover:text-primary focus:outline-none" data-id="element-2003">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-2004" /> : <MenuIcon className="h-6 w-6" data-id="element-2005" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-b border-gray-200" data-id="element-2006">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-2007">
            <Link to="/home1" className="block px-3 py-2 text-dark hover:text-primary flex items-center gap-2" onClick={() => setIsMenuOpen(false)} data-id="element-2008">
              <HomeIcon className="h-4 w-4" data-id="element-2009" />
              Home
            </Link>
            <a href="/#platforms" className="block px-3 py-2 text-dark hover:text-primary cursor-pointer" onClick={() => setIsMenuOpen(false)} data-id="element-2010">
              {t('nav.products')}
            </a>
            <Link to="/pricing" className="block px-3 py-2 text-dark hover:text-primary" onClick={() => setIsMenuOpen(false)} data-id="element-2011">
              {t('nav.pricing')}
            </Link>
            <Link to="/compare-to-intercom" className="block px-3 py-2 text-dark hover:text-primary" onClick={() => setIsMenuOpen(false)} data-id="element-2012">
              Compare To Intercom
            </Link>
            <Link to="/blog" className="block px-3 py-2 text-dark hover:text-primary flex items-center" onClick={() => setIsMenuOpen(false)} data-id="element-2013">
              <BookOpenIcon className="h-4 w-4 mr-2" data-id="element-2014" />
              {t('nav.blog')}
            </Link>
            <a href="https://shoppingexpert.ai" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 text-dark hover:text-primary" data-id="element-2015">
              {t('nav.shoppingExpert')}
            </a>
            <div className="flex flex-col space-y-2 px-3 py-2" data-id="element-2016">
              <a href="https://chat.shopilots.com/signup?product=shopilots" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-4 rounded-xl font-semibold transition-all flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-2017">
                <RocketIcon className="h-4 w-4" data-id="element-2018" />
                Try Now
              </a>
            </div>
          </div>
        </div>}

      {/* Wizard Modal */}
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2019" />
    </nav>;
};
export default Navbar;